import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { PerformanceIncomeModel } from '../../../Models/Models/PortfolioAnalysis/Performance/PerformanceIncomeModel';
import { IJsonDate } from '../../../System/IJsonDate';
import { PerformanceIncomeDataView } from '../../../Constants/Enums/Portfolio/Performance/PerformanceIncomeDataView';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientPerformanceIncomeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(headHierarchyIds: Array<string>, hierarchyIds: Array<string>, fromDateTime: IJsonDate, toDateTime: IJsonDate, fromInception: boolean, selectedView: PerformanceIncomeDataView): Promise<PerformanceIncomeModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Performance/ClientPerformanceIncome/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { headHierarchyIds: headHierarchyIds, hierarchyIds: hierarchyIds, fromDateTime: fromDateTime, toDateTime: toDateTime, fromInception: fromInception, selectedView: selectedView }

    return AjaxWrapper.get<PerformanceIncomeModel, any>(url, data);
  }
}

